import { HttpParams } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { ArticoliDisponibili } from 'src/app/entities/invoices';
import { LoginService, UserData } from 'src/app/services/login/login.service';
import { ToastService } from 'src/app/services/toast/toast.service';
import { UserService } from 'src/app/services/users/user.service';

@Component({
  selector: 'app-articoli-disponibili',
  templateUrl: './articoli-disponibili.component.html',
  styleUrls: ['./articoli-disponibili.component.css']
})
export class ArticoliDisponibiliComponent implements OnInit {
  titleSearch: string = "";
  loading : boolean = false;
  first: boolean = true;
  listArticoli : ArticoliDisponibili[] | undefined;

  constructor(public translate: TranslateService, public activeModal: NgbActiveModal, private loginService: LoginService, 
              private userService: UserService, private toastService: ToastService) { }

  async ngOnInit(){
    await this.search(null);
  }

  public selectOne(doc: ArticoliDisponibili){
    if(doc.selected){
      this.listArticoli!.filter(d => d.id != doc.id).forEach(d => d.selected = false);
    }
  }

  search(event: any){
    if(!event || event.keyCode == 13){
      this.retriveList();
    }
  }

  private async retriveList(){
    this.loading = true;
    this.listArticoli = [];
    //let userInfo = await this.loginService.getSessionUserInfo();
    let userInfo: UserData = JSON.parse(localStorage.getItem("einvuser") || "");
    let params = new HttpParams();
    params = params.append('endRow', 0);
    params = params.append('lastKeyVal', '');
    params = params.append('page', 1);
    params = params.append('pageDirection', 'FORWARD');
    params = params.append('pageSize', 12);
    params = params.append('pagination', true);
    params = params.append('paginationMode', 'SKIP');
    if(this.titleSearch != ""){
      params = params.append('searchFilter', '{\"descrizione\":\"' + this.titleSearch + '\"}');
    }
    params = params.append('sortDir', 'ASC');
    params = params.append('sortKey', 'descrizione');
    params = params.append('startRow', 0);
    params = params.append('totalPages', -1);
    params = params.append('totalRows', 0);
    
    let response = await this.userService.getArticoliDisponibili(userInfo!.user_id, params);
    if(response && response.success){
      this.listArticoli = response.data as ArticoliDisponibili[];
      this.first = false;
      this.loading = false;
    } else {
      this.toastService.openToast("Nessun articolo trovato, crealo nel menu configurazione", "warning");
      this.activeModal.close(null);
    }
  }


  close(){
    this.activeModal.close(null);
  }

  public save(){
    if(this.listArticoli!.filter(d => d.selected).length > 0){
      this.activeModal.close(this.listArticoli!.filter(d => d.selected)[0]);
    } else {
      this.activeModal.close(null);
    }
  }
}
